export class SearchDTO {
    constructor() {
        this.zipcode = '';
        this.city = '';
        this.state = '';
        this.lat = 40.730610;
        this.lng = -73.935242;
        this.keyword = '';
        this.userAllowedLocation = false;
    }
    zipcode?: string;
    city?: string;
    state?: string;
    lat?: any;
    lng?: any;
    keyword?: any;
    locationName?:string;
    userAllowedLocation?:boolean;
}